import { Box, Modal, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SecondaryButton from "../../../../components/buttons/SecondaryButton";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
};
const TrackingToolRequiredModal = ({ open, handleClose }) => {
  const navigate = useNavigate();
  const handleHeSystemConnect = () => {
    navigate("/inventory/integrations", {
      state: { filterIntegration: "Ticketing" },
    });
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={style}>
        <>
          <Typography variant="subtitle1">
            A change management tool, e.g. Jira, must be integrated for using
            Tracking capabilities.
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              mt: 2,
            }}
          >
            <SecondaryButton onClick={handleHeSystemConnect}>
              Setup your first ticketing tool integration
            </SecondaryButton>
          </Box>
        </>
      </Box>
    </Modal>
  );
};

export default TrackingToolRequiredModal;
